module.exports = __webpack_public_path__ + "img/5a6a049.jpg";